// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAuth, updateStatus, updateSapNumber, getUserByIdQuery, getCaptchaQuery, getUserCompanies } from "../../api/authApi"; // Add necessary imports
import { fetchUserTable } from "../../api/userApi";
 
// Login User
export const login = createAsyncThunk(
  "auth/login",
  async (data: { email: string; password: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await getAuth(data);
    } catch (error: any) {
      // console.log(error, "error");
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);



// Update Status
export const updateUserStatus = createAsyncThunk(
  "auth/updateStatus",
  async (
    { userId, status }: { userId: string; status: string },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateStatus(userId, status);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Update SAP Number
export const updateUserSap = createAsyncThunk(
  "auth/updateSap",
  async (
    {
      user_id,
      sap_no,
      exp_date,
      health_exp_date,
      email,
      legalApprove,
      commercialApprove,
      userApprovals,
    }: {
      user_id: string;
      sap_no: string;
      exp_date: string;
      health_exp_date: string;
      email: string;
      legalApprove: boolean;
      commercialApprove: boolean;
      userApprovals?: any[];
    },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateSapNumber(
        user_id,
        sap_no,
        exp_date,
        health_exp_date,
        email,
        legalApprove,
        commercialApprove,
        userApprovals
      );
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Get a user's linked companies for per-company approvals
export const getUserCompaniesList = createAsyncThunk(
  "auth/userCompanies",
  async (user_id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await getUserCompanies(user_id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const getUserById = createAsyncThunk(
  "auth/getUserById",
  async (
    user_id: string,
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await getUserByIdQuery(user_id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// User Table
export const userTable = createAsyncThunk(
  "auth/userTable",
  async ({ page, limit, userType }: { page: number; limit: number, userType: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchUserTable(page, limit, userType);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCaptcha = createAsyncThunk("auth/getCaptcha", async (_: void, { dispatch, rejectWithValue }) => {
  try {
    console.log("called inside slice ");
    dispatch(resetStatus());
    return await getCaptchaQuery();
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
}
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: [] as any[],
    users: [] as any[],
    userCompanies: [] as any[],
    status: null as boolean | null,
    msg: "",
    captchaLoading: false,
    captchaData: null as any,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },

    logout(state) {
      state.status = null;
      state.msg = "";
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        // // console.log(action.payload, "action.payload.data");
        state.user = action.payload.data;
      })
      .addCase(getUserById.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.user = action.payload.data;
      })
      .addCase(userTable.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.users = action.payload;
      })

      .addCase(updateUserStatus.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.msg = "User status updated successfully!";
      })
      .addCase(updateUserSap.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.msg = "SAP number updated successfully!";
      })
      .addCase(getUserCompaniesList.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.userCompanies = action.payload.data;
      })
      .addCase(login.rejected, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.msg = action.payload || "Login failed!";
      })
      .addCase(getUserById.rejected, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.msg = action.payload || "Login failed!";
      })
      .addCase(userTable.rejected, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.msg = action.payload || "Failed to fetch user table!";
      })

      .addCase(updateUserStatus.rejected, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.msg = action.payload || "Failed to update user status!";
      })
      .addCase(updateUserSap.rejected, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.msg = action.payload || "Failed to update SAP number!";
      })

      .addCase(getCaptcha.pending, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.captchaLoading = true;
      })
      .addCase(getCaptcha.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.captchaLoading = false;
        state.captchaData = action.payload;
        state.msg = action.payload || "Failed to update SAP number!";
      })
      .addCase(getCaptcha.rejected, (state, action: PayloadAction<any>) => {
        state.status = false;
        state.captchaLoading = false;
        state.msg = action.payload || "Failed to get captcha!";
      });
  },
});

export const { resetStatus, logout } = authSlice.actions;
export default authSlice.reducer;
